/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, {   useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import TextField from '../TextField'
import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import _ from 'lodash'
import {useDropzone} from 'react-dropzone'
import WarningModal from 'component/scheduleBlock/WarningModal'
import ClearSVG from 'component/svgComponents/clear'
import { isEmpty } from 'utils/validations'
import { v4 as uuidv4 } from 'uuid';
import Tooltip from './tooltip'
import PictogramModalErrorNew from 'component/pictograms/PictogramErrorModalNew'
import { useDebounce } from './debounce'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'


const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const PictogramEditModal = ({
  closeModal,
  attribute,
  attributeAlreadyExists,
  handleAttributeAlreadyExists,
  token,  
  translate,
  action
}) => {

  // eslint-disable-next-line react/prop-types
  const [pictograms,setPictograms] = useState([])
  const [attributeName,setAttributeName] = useState(attribute.name)
  const [hasScroll,setHasScroll] = useState(false)
  const [warningModal,setWarningModal] = useState(false)
  const [repeteadNames, setRepeatedNames] = useState([])
  const [openUploadErrorModal, setOpenUploadErrorModal] = useState(false)
  const [openWarningUploadModal, setopenWarningUploadModal] = useState(false)
  const [attributeNameAlreadyExists, setAttributeNameAlreadyExists] = useState(false)

  useEffect(() =>  {
    const newArray = JSON.parse(JSON.stringify(attribute.pictograms));
    setPictograms(newArray)
    
  } ,[])

  const onChange = () => {
  
   if(attribute.name === attributeName) return
   new Api(token)
  .get(API_URL.CHECK_ATTRIBUTE_NAME, {name: attributeName})
  .then((response) => {
    
    setAttributeNameAlreadyExists(response.data)
  })
  .catch((error) => {
    console.log("error", error)
  })
   
  };

  const debouncedOnChange = useDebounce(onChange);

  useEffect(() =>  {
    setHasScroll(pictograms.length >= 4)
  }, [pictograms])

  // eslint-disable-next-line react/prop-types
  const PictogramDropzone = ({index, onDrop, onFileDialogCancel, img, pictograms, changeMode,isCharged}) => {

    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles) => onDrop(acceptedFiles, index),
      onFileDialogCancel: () => onFileDialogCancel(index),
      accept: {
        'image/jpeg': [],
        'image/png': []
      },
      multiple: true
      
    });
  
    return (
      changeMode ? 
      <div style={{margin: isCharged && '0 auto'}}> 
        <button style={{marginBottom: '5px'}} {...getRootProps()} id='pictogram-change-delete'>Alterar</button> 
        <input {...getInputProps()} /> 

      </div>
      : 
      <div className='pictogram-box' style={{marginTop: pictograms && pictograms.length > 0 ? '28px': '0px'}} {...getRootProps()}>
        <input {...getInputProps()} />
        {renderImageOrSVG(img)}
      </div>
    );


  }

  const handleDrop = (files, index) => {
    const file = files[0]

    if(!file) {
      setOpenUploadErrorModal(true)
      return
      
    }
    const newPictograms = [...pictograms]
    if(index === -1 ) index = 0
    
    
    if(typeof pictograms[index] === 'undefined' ) {
      
      files.forEach(currentFile => {
        const pictogram = {url: URL.createObjectURL(currentFile) , img: URL.createObjectURL(currentFile), file:currentFile, changed: true, uuid: uuidv4()}
        newPictograms.push(pictogram)
      })

    }

    else if(!pictograms[index].id) {
      if(files.length > 1) {
        setopenWarningUploadModal(true)
        return
      }

      newPictograms[index].changed = true
      newPictograms[index].url = URL.createObjectURL(file)
      newPictograms[index].file = file
    }

    else {

      if(files.length > 1) {
        setopenWarningUploadModal(true)
        return
      }

      newPictograms[index].changed = true
      newPictograms[index].url = URL.createObjectURL(file)
      newPictograms[index].file = file
    }
    setPictograms(newPictograms)
  
  }

  PictogramDropzone.propTypes = {
    index: PropTypes.number.isRequired,
    img: PropTypes.string,
    pictograms: PropTypes.array
  }

  const handleDialogCancel = (index) => {

    if(typeof pictograms[index] !== 'undefined' && index !== -1 && index !== pictograms.length ) return
    const newPictograms = [...pictograms]
    newPictograms.push({uuid: uuidv4()})
    setPictograms(newPictograms)
  }
  const renderImageOrSVG = (img) => {

    if(img) {
      return <div>
        <img style={{width: '111px', height: '112px', padding: '5px', display: 'flex'}} src={img} />
       
      </div>
    }

    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2 8.8V0H8.8V8.8H0V11.1H8.8V20H11.1L11.2 11.1H20V8.8H11.2Z" fill="#41A017"/>
           </svg>
  }

  const handleDeletePictogram = (index) => {
    const updatedPictograms = [...pictograms]
    if(pictograms[index].img) {
      updatedPictograms[index].img = null
      updatedPictograms[index].file = null
      
    }

    else if(pictograms[index].url) {
      pictograms[index].url = null
      pictograms[index].changed = true
      
    }

    else {
  
      updatedPictograms.splice(index,1)
      
    }
    setPictograms(updatedPictograms);
  }
  // eslint-disable-next-line react/prop-types
  const renderPictogramsImages = () =>   pictograms.map((pictogram,index) => 
  
    <div key={pictogram.id ? pictogram.id : pictogram.uuid }>
      {attribute.isCharge
      
      ? <Tooltip direction="top" delay={1} content={pictogram.name}>
          <p  
          id={pictogram.name} 
          style={{marginLeft: '0px', maxWidth: '120px', whiteSpace:"nowrap", overflow: "hidden", textOverflow: "ellipsis"}} 
          className='pictogram-view-name'>{pictogram.name}
          </p>
      
        </Tooltip> :

      <div className='pictogram-input-div'>
       
        <ClearSVG className={`${pictogram.name ? "pictogram-input-clear" : "hide-shadow"}`} onClick={() => {
          const updatedPictograms = [...pictograms]
          updatedPictograms[index].name = ""
          setPictograms(updatedPictograms)
        }} />

        <input  style={{paddingRight: '30px',border: (repeteadNames.filter(n => n !== "").includes( (pictogram.name || "").toLowerCase().trimEnd()) || attribute.pictograms.some(pictog => (pictog.name || "").toLowerCase().trimEnd() ===  (pictogram.name || "").toLowerCase().trimEnd()) && !pictogram.id ) && '1px solid #b42a27'}}   placeholder='Digite um nome' className='pictograms-box-input' type='text' value={pictogram.name} onChange={(e) => {
        
        const updatedPictograms = [...pictograms]
        updatedPictograms[index].name = e.target.value.trimStart()
        setPictograms(updatedPictograms)
        
        const names = updatedPictograms.map((input) => (input.name || "").toLowerCase().trimEnd());
        const duplicateNames = names.filter(
            (name, i) => names.indexOf(name) !== i 
          );

        setRepeatedNames(duplicateNames);
          
        } } />

        
    </div>
      }
      
      <PictogramDropzone 
        index={index} 
        onDrop={handleDrop} 
        onFileDialogCancel={handleDialogCancel} 
        img={pictogram.url} 
        key={pictogram.name} 
        className='pictogram-box'/>

      
      <div className='pictogram-actions'>

        <PictogramDropzone 
          index={index} 
          isCharged={attribute.isCharge}
          onDrop={handleDrop} 
          onFileDialogCancel={handleDialogCancel} 
          img={pictogram.url}
          changeMode 
          key={pictogram.name} 
          className='pictogram-box'/>

        {!attribute.isCharge && <button id='pictogram-img-delete' onClick={() => {
          handleDeletePictogram(index)
        }}>Excluir</button> 
        }
      </div>
    </div>  
       )
  // eslint-disable-next-line react/prop-types
  const renderPictograms = () => <PictogramDropzone pictograms={pictograms} index={pictograms.length} onDrop={handleDrop} onFileDialogCancel={handleDialogCancel}  />

  const hasDuplicateName = pictograms.some(newPictogram => attribute.pictograms.some(originalPictogram =>
      originalPictogram.name === newPictogram.name && !newPictogram.id
    ));

  pictograms.map(p => attribute.pictograms.some(pictogram => pictogram.name === p.name && pictogram.id !== p.id))
  const isButtonDisabled = !attributeName.trim() || (attributeAlreadyExists || attributeNameAlreadyExists )  || attribute.name === attributeName && _.isEqual(attribute.pictograms,pictograms) || pictograms.some(t => !t.name) || repeteadNames.length > 0 || isEmpty(pictograms) || hasDuplicateName

  const convertFileToBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const handleEditSubmit = async () => {
    const pictogramsWithBase64 = await Promise.all(
      pictograms.map(async (pictogram) => {
        const base64 = pictogram.file ? await convertFileToBase64(pictogram.file) : null;
        return {
          id: pictogram.id,
          name: pictogram.name,
          url: pictogram.url,
          bucketName: pictogram.bucketName,
          mediaUrl: pictogram.mediaUrl,
          filePath: pictogram.filePath,
          img: base64,
          changed: !!pictogram.changed
        };
      })
    );

    const jsonData = {
      ...(attribute.name !== attributeName.trim() && { name: attributeName.trim() }),
      pictogramParams: pictogramsWithBase64
    };

    action(jsonData, attribute.id);
  };
  const handleCloseModal = () => {
    if(!_.isEqual(attribute.pictograms, pictograms) ) {
      setWarningModal(true)
    }
    else {
      closeModal()
    }
  }

  const renderWarningModalWeekly = () => {

    if(!warningModal) return
    const handleConfirm = () => {
      setAttributeName("")
      setPictograms([])
      setWarningModal(false)
      closeModal()
    }

    const handleCancel = () => {
      setWarningModal(false)
    }

    return (
      <WarningModal
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        translate={translate}
      />
    )

  }

  const renderUploadErrorModal = () => {
    if(!openUploadErrorModal) return
    return (
      <PictogramModalErrorNew
        above
        onConfirm={() => setOpenUploadErrorModal(false)}
        text={"Houve um erro ao adicionar a imagem no pictograma"}
        title={'Ops!'}
        details={"Formato não suportado"}
        okButton={'Tentar novamente'}
      />
    )
  }

  const renderWarningUploadModal = () => {
    if(!openWarningUploadModal) return
    return (
      <PictogramModalErrorNew
        above
        onConfirm={() => setopenWarningUploadModal(false)}
        text={"Houve um erro ao adicionar as imagens no pictograma"}
        title={'Ops!'}
        details={"arraste as imagens para o bloco de adição "}
        okButton={'Tentar novamente'}
      />
    )
  }

  return (
    <>
      {renderUploadErrorModal()}
      {renderWarningModalWeekly()}
      {renderWarningUploadModal()}
    
      <Modal
        onCloseModal={handleCloseModal}
        size='md'
        under
        className={`pictograms-add-modal ${warningModal ? 'hide-shadow' : ''}`}
      >
        <h3 style={{fontSize: '24px', marginBottom:'32px', marginTop: '-1px', paddingTop: '4px'}}>
          <strong style={{color: 'black'}}>Editar cadastro de atributo</strong>
        </h3>

        <p style={{marginBottom:'-10px', color: '#222020', fontWeight: '600', fontSize: '13px'}}>Atributo</p>
       
        <TextField
                    type='text'
                    required
                    clearIcon
                    onRightIconClick={() => setAttributeName("")}
                    onChange={(e) => {
                      debouncedOnChange()
                      setAttributeName(e.target.value)
                      if(attributeAlreadyExists || attributeNameAlreadyExists) {
                        handleAttributeAlreadyExists(false)
                        setAttributeNameAlreadyExists(false)
                      }
                    }}
                    value={attributeName}
                    placeholder="Digite um nome de atributo"
                    fill
                    errorMsg="Já existe um atributo com esse nome"
                    error={attributeAlreadyExists || attributeNameAlreadyExists}
                    
                  
                  />
        
        <p style={{marginBottom:'16px', color: '#222020', fontWeight: '600', fontSize: '13px'}}>Pictogramas</p>
        
        <section className={`pictograms-area ${hasScroll ? 'pictogram-border' : ''}`} >
            
            {renderPictogramsImages()}
            {!attribute.isCharge && renderPictograms()}
            
        </section>
      
        <div className='mission-block-new-modal-actions'>

          <button
            disabled={isButtonDisabled}
            onClick={handleEditSubmit}
            className='mission-save'
          >
            {translate('save_button_label')}
          </button>

          <button
            onClick={handleCloseModal}
            className='mission-cancel'
          >
          {translate('close_button_label')}
          </button>


        </div>
      </Modal>
    </>
    
  )
}

PictogramEditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  attribute: PropTypes.object.isRequired
}


export default Form({ fields: FIELDS })(PictogramEditModal)

export { PictogramEditModal }
